import { Box, SxProps, Typography } from "@mui/material"
import React from "react"

export const LayoutBox = ({ children, sx }: { children?: React.ReactNode, sx?: SxProps }) => {
    return <Box sx={{
        height: '100vh',
        width: '100%',
        background: '#fff',
        color: '#000',
        p: 0,
        m: 0,
        ...sx
    }}>
        {children}
    </Box>
}

export const Data = ({ children, sx }: { children?: React.ReactNode, sx?: SxProps }) => {
    return <Typography sx={{ fontSize: 16, ...sx }}>
        {children}
    </Typography>
}